import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { ThemeManager } from "@/features/admin/components/theme-manager";
import { PageContainer } from "@fleet/ui/page-container";

function AdminThemesPage() {
  return (
    <PageContainer maxWidth="6xl">
      <ThemeManager />
    </PageContainer>
  );
}

export const adminThemesRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/themes",
  component: AdminThemesPage,
});
